module.exports = __webpack_public_path__ + "img/a1_password_link_erroe.4ca7a3e3.jpg";